/**
 * @Description 点位评测
 */
import { get, post } from '@/common/request/index';

/**
 * 点位评测详情
 * https://yapi.lanhanba.com/project/532/interface/api/78518
 */
export function spotEvaluationDetail(params: any) {
  return post('/spot/evaluation/detail', { ...params });
}

/**
 * 点位评测概要
 * https://yapi.lanhanba.com/project/349/interface/api/77622
 */
export function spotEvaluationOverview(params: any) {
  return post('/spot/evaluation/overview', { ...params });
}

/**
 * 经营门店tab
 * https://yapi.lanhanba.com/project/349/interface/api/77671
 */
export function spotEvaluationLevelCount(params: any) {
  return post('/spot/evaluation/levelCount', { ...params });
}

/**
 * 经营门店明细
 * https://yapi.lanhanba.com/project/349/interface/api/77874
 */
export function spotEvaluationLevelPage(params: any, config?: any) {
  return post('/spot/evaluation/levelPage', { ...params }, config);
}

/**
 * 知名品牌门店分页列表
 * https://yapi.lanhanba.com/project/349/interface/api/77825
 */
export function getSpotEvaluationFamousBrandPage(params: any, config?: any) {
  return post('/spot/evaluation/famous/brand/page', { ...params }, config);
}

/**
 * 竞品品牌分页接口
 * https://yapi.lanhanba.com/project/511/interface/api/73345
 */
export function postSpotEvaluationCompetitorsPage(params: any, config?: any) {
  return post('/spot/evaluation/competitorsPage', { ...params }, config);
}

/**
 * 点位测评-图例【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77657
 */
export function spotEvaluationLegend(params: any) {
  return post('/spot/evaluation/legend', { ...params });
}

/**
 * 点位测评-客流画像【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77776
 */
export function spotEvaluationPopulation(params: any) {
  return post('/spot/evaluation/population', { ...params });
}

/**
 * 点位测评-周边配套tab【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77706
 */
export function spotEvaluationAroundCategory(params: any) {
  return post('/spot/evaluation/arroundCategory', { ...params });
}

/**
 * 点位测评-周边信息【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77741
 */
export function spotEvaluationSurround(params: any) {
  return post('/spot/evaluation/surround', { ...params });
}

/**
 * 点位测评历史列表
 * https://yapi.lanhanba.com/project/546/interface/api/84769
 */
export function spotEvaluationHistory(params: any) {
  return post('/spot/evaluation/record/page', { ...params });
}

/**
 * 点位测评历史记录-奥乐齐：上传pipeline
 * https://yapi.lanhanba.com/project/532/interface/api/98496
 */
export function uploadPipeline(params: any) {
  return post('/spot/evaluation/record/uploadPipeline', { ...params });
}

/**
 * 点位测评历史记录-奥乐齐：查询上传pipeline状态
 * https://yapi.lanhanba.com/project/532/interface/api/98516
 */
export function getPipelineStatus(params: any) {
  return post('/spot/evaluation/record/getUploadPipelineStatus', { ...params });
}

/**
 * 查询半径经纬度
 */
export function spotEvaluationModel() {
  return post('/spot/evaluation/model', {});
}

/**
 * 根据经纬度获得poi名称
 * https://yapi.lanhanba.com/project/469/interface/api/75172
 */
export function getTargetPOIInfo(params?: any) {
  return post('/amap/location', { ...params }, {
    // isMock: true,
    needHint: true,
    needCancel: false,
    isFlowV2: true
  });
}

/**
 * 点位测评-周边配套列表【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/97180
 */
export function getSpotEvaluationAroundPage(params:any, config?: any) {
  return post(`/spot/evaluation/arroundPage`, params, config);
}

/**
 * 点位测评-查询周边小区聚合信息
 * https://yapi.lanhanba.com/project/546/interface/api/98214
 */
export function postSpotEvaluationCommunityAggregate(params:any, config?: any) {
  return post(`/spot/evaluation/surround/community/aggregate`, params, config);
}


const SPOT_EVALUATION_RECORD_POLYGON_OPTIONS = { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true, needCancel: false };

/**
 * 根据id查询点位测评报告的围栏
 * https://yapi.lanhanba.com/project/532/interface/api/100854
 */
export function spotEvaluationRecordPolygon(params: any) {
  return post('/spot/evaluation/record/polygon', params, SPOT_EVALUATION_RECORD_POLYGON_OPTIONS);
}

const COMMUNITY_MAIN_LIST_OPTIONS = { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true, needCancel: false };

/**
 * 点位测评-小区主列表（主小区分页，内嵌 phaseList 分期小区）
 * https://yapi.lanhanba.com/project/532/interface/api/100524
 */
export function spotEvaluationCommunityMainList(params: any) {
  return post('/spot/evaluation/surround/community/mainList', params, COMMUNITY_MAIN_LIST_OPTIONS);
}

const COMMUNITY_EXPORT_OPTIONS = { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true, needCancel: false };

/**
 * 点位测评-小区信息异步导出
 * https://yapi.lanhanba.com/project/532/interface/api/100878
 */
export function spotEvaluationCommunityExport(params: any) {
  return post('/spot/evaluation/surround/community/export', params, COMMUNITY_EXPORT_OPTIONS);
}

// =======================分享接口=======================
/**
 * 点位评测详情
 */
export function spotEvaluationDetailShare(params: any) {
  return post('/spot/evaluation/share/detail', { ...params });
}

/**
 * 点位评测概要
 */
export function spotEvaluationOverviewShare(params: any) {
  return post('/spot/evaluation/share/overview', { ...params });
}

/**
 * 点位测评-经营门店tab-分享【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77699
 */
export function spotEvaluationLevelCountShare(params: any) {
  return post('/spot/evaluation/share/levelCount', { ...params });
}

/**
 * 点位测评-经营门店列表-分享【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77972
 */
export function spotEvaluationLevelPageShare(params: any, config?: any) {
  return post('/spot/evaluation/share/levelPage', { ...params }, config);
}

/**
 * 点位评测图例
 * https://yapi.lanhanba.com/project/349/interface/api/77664
 */
export function spotEvaluationLegendShare(params: any) {
  return post('/spot/evaluation/share/legend', { ...params });
}

/**
 * 点位测评-客流画像-分享【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77804
 */
export function spotEvaluationPopulationShare(params: any) {
  return post('/spot/evaluation/share/population', { ...params });
}

/**
 * 周边配套 tab接口（返回一二级tab及对应数量）
 * https://yapi.lanhanba.com/project/349/interface/api/75438
 */
export function spotEvaluationAroundCategoryShare(params: any) {
  return post('/spot/evaluation/share/arroundCategory', { ...params });
}

/**
 * 点位测评-周边信息-分享【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77748
 */
export function spotEvaluationSurroundShare(params: any) {
  return post('/spot/evaluation/share/surround', { ...params });
}

/**
 * 点位测评-知名品牌门店分页列表-分享【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77839
 */
export function famousBrandDataListShare(params: any, config?: any) {
  return post('/spot/evaluation/share/famous/brand/page', { ...params }, config);
}

/**
 * 竞品品牌分页接口
 * https://yapi.lanhanba.com/project/511/interface/api/73345
 */
export function surroundCompetitorsPagePOIDataListShare(params: any, config?: any) {
  return post('/spot/evaluation/share/competitorsPage', { ...params }, config);
}

/**
 * 点位测评-周边配套列表-分享【PC】
 * https://yapi.lanhanba.com/project/349/interface/api/77937
 */
export function getSpotEvaluationAroundPageShare(params:any, config?: any) {
  return post(`/spot/evaluation/share/arroundPage`, params, config);
}

/**
 * 点位测评-查询周边小区聚合信息（分享）
 * https://yapi.lanhanba.com/project/546/interface/api/98216
 */
export function postSpotEvaluationCommunityAggregateShare(params:any, config?: any) {
  return post(`/spot/evaluation/share/surround/community/aggregate`, params, config);
}

/**
 * 点位评测生成查询记录
 * https://yapi.lanhanba.com/project/546/interface/api/84720
 */
export function saveRecord(params: any) {
  return post('/spot/evaluation/saveRecord', { ...params });
}

/**
 * 点位评测商场类型选择
 * https://yapi.lanhanba.com/project/349/interface/api/77538
 */
export function getMallShopList(params: any) {
  return post('/spot/evaluation/mallShop/pageList', { ...params });
}

/**
 * 点位测评-导出PDF
 * https://yapi.lanhanba.com/project/546/interface/api/89276
 */
export function postSpotEvaluationExportExportData(params: any) {
  return post('/spot/evaluation/export/export/data', { ...params });
}

/**
 * 点位测评历史详情
 * https://yapi.lanhanba.com/project/532/interface/api/89411
 */
export function getSpotEvaluationRecordDetail(params: any) {
  return post('/spot/evaluation/record/detail', { ...params }, { mockId: 532, isMock: false });
}

/**
 * 点位测评-获取配置信息
 * https://yapi.lanhanba.com/project/546/interface/api/92747
 */
export function getSpotEvaluationConfigData(params: any) {
  return get('/spot/evaluation/configData', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}

/**
 * 点位测评-获取配置信息 - 分享
 */
export function getSpotEvaluationShareConfigData(params: any) {
  return get('/spot/evaluation/share/configData', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}


/**
 * 点位测评- 获取门店状态的数量
 * https://yapi.lanhanba.com/project/349/interface/api/97252
 */
export function postShopStatusCount(params: any) {
  return post('/spot/evaluation/shopStatusCount', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}
/**
 * 点位测评- 获取门店状态的数量（分享）
 * https://yapi.lanhanba.com/project/349/interface/api/97396
 */
export function postShareShopStatusCount(params: any) {
  return post('/spot/evaluation/share/shopStatusCount', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}

/**
 * 点位测评- 城市GDP、人口等信息
 * https://yapi.lanhanba.com/project/349/interface/api/97220
 */
export function getSpotEvaluationCityInfo(params: any) {
  return get('/spot/evaluation/cityInfo', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}
/**
 * 点位测评- 选址地图- 城市GDP、人口等信息（分享）
 * https://yapi.lanhanba.com/project/349/interface/api/97364
 */
export function postShareSpotEvaluationCityInfo(params: any) {
  return post('/spot/evaluation/share/cityInfo', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}

/**
 * 点位测评- 本品牌开店趋势
 * https://yapi.lanhanba.com/project/349/interface/api/97244
 */
export function postQueryOpeningTendency(params: any) {
  return post('/spot/evaluation/queryOpeningTendency', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}

/**
 * 点位测评- 本品牌开店趋势（分享）
 * https://yapi.lanhanba.com/project/349/interface/api/97388
 */
export function postShareQueryOpeningTendency(params: any) {
  return post('/spot/evaluation/share/queryOpeningTendency', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}

/**
 * 点位测评- 竞品品牌开店趋势
 * https://yapi.lanhanba.com/project/349/interface/api/97228
 */
export function postQueryMonthTendency(params: any) {
  return post('/spot/evaluation/queryMonthTendency', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}

/**
 * 点位测评- 竞品品牌开店趋势（分享）
 * https://yapi.lanhanba.com/project/349/interface/api/97372
 */
export function postShareQueryMonthTendency(params: any) {
  return post('/spot/evaluation/share/queryMonthTendency', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}


/**
 * 点位测评- 关注品牌（省市区模式）
 * https://yapi.lanhanba.com/project/349/interface/api/97236
 */
export function postCombatMapQueryTendencyV2(params: any) {
  return post('/spot/evaluation/combatMap/queryTendencyV2', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}


/**
 * 点位测评- 关注品牌（省市区模式）（分享）
 * https://yapi.lanhanba.com/project/349/interface/api/97380
 */
export function postShareCombatMapQueryTendencyV2(params: any) {
  return post('/spot/evaluation/share/combatMap/queryTendencyV2', { ...params }, { mockId: 546, isMock: false, needCancel: false });
}


/**
 * 点位测评-导出-pdf-周边配套tab接口（返回一二级tab及对应数量）
 * https://yapi.lanhanba.com/project/349/interface/api/98298
 */
export function evaluationPDFArroundCategory(params: any) {
  return post('/spot/evaluation/export/pdf/arroundCategory',
    { ...params },
    { mockId: 349, isMock: false }
  );
}


/**
 * 点位测评-导出-pdf-周边配套 poi分页列表
 * https://yapi.lanhanba.com/project/349/interface/api/98300
 */
export function evaluationPDFArroundPage(params: any) {
  return post('/spot/evaluation/export/pdf/arroundPage',
    { ...params },
    { mockId: 349, isMock: false }
  );
}


/**
 * 奥乐齐-点位测评-经营门店-竞品门店-计算竞品品牌系数接口
 * https://yapi.lanhanba.com/project/532/interface/api/98518
 */
export function competitorsCoefficient(params: any) {
  return post('/spot/evaluation/competitorsCoefficient',
    { ...params },
    { mockId: 532, isMock: false }
  );
}


/**
 * 奥乐齐-点位测评-经营门店-竞品门店-计算竞品品牌系数接口-分享
 * https://yapi.lanhanba.com/project/349/interface/api/98520
 */
export function competitorsCoefficientShare(params: any) {
  return post('/spot/evaluation/share/competitorsCoefficient',
    { ...params },
    { mockId: 532, isMock: false }
  );
}

const COMMUNITY_AGG_LIST_V2_OPTIONS = { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true, needCancel: false };

/**
 * 点位测评-查询周边小区统计（支持多个二级类型查询）
 * https://yapi.lanhanba.com/project/532/interface/api/100536
 */
export function communityAgglistV2(params: any) {
  return post('/spot/evaluation/surround/community/aggListV2', params, COMMUNITY_AGG_LIST_V2_OPTIONS);
}

/**
 * 点位测评-编辑点位测评标题
 * https://yapi.lanhanba.com/project/546/interface/api/99166
 */
export function editEvaluationTitle(params: any) {
  return post('/spot/evaluation/record/update',
    { ...params },
    { mockId: 546, isMock: false }
  );
}
